import { anyType, fiwareDataItemType } from "../../types";
import { LegendTableType } from "../../types/components/legend";

/**
 * 凡例表示用のプロパティを生成する
 */
export const updateLegendProperties = (
  item: anyType,
  legendTableData: Record<string, anyType> | undefined
): { id: string | undefined, legendProperties: { [key: string]: string | undefined | LegendTableType } } => {
  const metadata = 'metadata' in item ? item.metadata : {};

  const legendProperties: { [key: string]: string | undefined | LegendTableType } = {
    fill: 'fill' in metadata ? metadata.fill : undefined,
    stroke: 'stroke' in metadata ? metadata.stroke : undefined,
    marker_color: 'marker-color' in metadata ? metadata['marker-color'] : undefined,
    'marker-symbol': 'marker-symbol' in metadata ? metadata['marker-symbol'] : undefined,
    isAlert: 'dataType' in metadata && metadata.dataType === 'Alert' ? 'isAlert' : undefined,
    legendTable: 'metadata' in item && 'legendTable' in item.metadata ? item.metadata.legendTable : undefined
  };

  const id = item.dataType === 'fiware' ? item.dataId : (item as unknown as fiwareDataItemType).tileId;

  // fiwareだったらlegendTableを更新
  if (item.dataType === 'fiware') {
    const fiwareLegend = legendTableData ? legendTableData[id] : undefined;

    if (fiwareLegend) {
      if (Object.keys(fiwareLegend).length === 1 && Object.keys(fiwareLegend)[0] in legendProperties) {
        legendProperties[Object.keys(fiwareLegend)[0]] = Object.values(fiwareLegend)[0] as string | LegendTableType | undefined;
      } else {
        legendProperties.legendTable = fiwareLegend;
      }
    }
  }
  // datapngだったらlegendTableを更新
  if ('metadata' in item && 'dataType' in item.metadata && item.metadata.dataType === 'datapng') {
    const datapngLegend = legendTableData ? legendTableData[id] : undefined;
    if (datapngLegend) { legendProperties.legendTable = datapngLegend; }
  }

  // rasterまたは、osmだったら 凡例なし を追加
  if (
    ('metadata' in item && 'dataType' in item.metadata && item.metadata.dataType === 'raster') ||
    item.dataType === 'osm'
  ) {
    legendProperties['msg'] = '凡例なし';
  }

  return {id, legendProperties};
};
